import {
  ExitToAppOutlined,
  GavelOutlined,
  HelpOutline,
  HomeOutlined,
  PanToolOutlined,
  PersonOutlined,
  Print,
  Search,
  VisibilityOutlined,
} from "@mui/icons-material";
import { ReactNode } from "react";

import { RegisterType } from "../common/interfaces/enums/RegisterType";
import { PermissionType } from "../common/interfaces/enums/PermissionType";
import { UserType } from "../common/interfaces/enums/UserType";

export type RouteItem = {
  Path: string;
  Label: string;
  Icon?: ReactNode;
  UserTypes?: UserType[];
  Permission?: PermissionType;
};

export type Crud = {
  Root: RouteItem;
  Search: RouteItem;
  Preview: RouteItem;
};

export type Register = {
  Register: RegisterType;
  Print: RouteItem;
  HistoryPreview: RouteItem;
} & Crud;

type CommonRoutesConfigProps = {
  Login: RouteItem;
  LoginRoute: RouteItem;
  AdminLogin: RouteItem;
  Logout: RouteItem;
  Help: RouteItem;
  NotFound: RouteItem;
  SSL: RouteItem;
  Forbidden: RouteItem;
  isRouteCommon: (pathname: string) => boolean;
};

export const CommonRoutesConfig: CommonRoutesConfigProps = {
  Login: { Label: "Вход", Path: "/login", Icon: <ExitToAppOutlined /> },
  LoginRoute: { Label: "Вход", Path: "/login/:uid", Icon: <ExitToAppOutlined /> },
  AdminLogin: { Label: "Вход", Path: "/admin/login", Icon: <ExitToAppOutlined /> },
  Logout: { Label: "Изход", Path: "/logout", Icon: <ExitToAppOutlined /> },
  Help: { Label: "Помощ", Path: "/help", Icon: <HelpOutline /> },
  Forbidden: { Label: "", Path: "/forbidden" },
  SSL: { Label: "", Path: "/ssl" },
  NotFound: { Label: "", Path: "*" },
  isRouteCommon: (pathname: string) => {
    let isCommonRoute = false;
    Object.keys(CommonRoutesConfig).forEach((prop) => {
      const path = (CommonRoutesConfig as any)[prop]["Path"];
      if (pathname.startsWith(path)) isCommonRoute = true;
    });
    return isCommonRoute;
  },
};

type PublicRoutesConfigProps = {
  Home: RouteItem;
  Profile: RouteItem;
  Authorization: Register;
  WithdrawnAuthorization: Register;
};

export const PublicRoutesConfig: PublicRoutesConfigProps = {
  Home: { Label: "Начало", Path: "/", Icon: <HomeOutlined /> },

  Profile: { Label: "Профил", Path: "/profile", Icon: <PersonOutlined /> },
  Authorization: {
    Register: RegisterType.Authorizations,
    Root: {
      Label: "Пълномощни",
      Path: "/authorizations",
      Icon: <GavelOutlined />,
      UserTypes: [UserType.BankUser],
      Permission: PermissionType.Read,
    },
    Search: { Label: "Търси", Path: "/authorizations", Icon: <Search />, Permission: PermissionType.Read },
    Preview: {
      Label: "Преглед",
      Path: "/authorizations/preview/:id",
      Icon: <VisibilityOutlined />,
      Permission: PermissionType.Read,
    },
    Print: { Label: "Принтирай", Path: "", Icon: <Print />, Permission: PermissionType.Read },
    HistoryPreview: { Label: "", Path: "/authorizations/history-preview/:id", Permission: PermissionType.Read },
  },
  WithdrawnAuthorization: {
    Register: RegisterType.WithdrawnAuthorizations,
    Root: {
      Label: "Оттеглени пълномощни",
      Path: "/withdrawnAuthorizations",
      Icon: <PanToolOutlined />,
      UserTypes: [UserType.BankUser],
      Permission: PermissionType.Read,
    },
    Search: { Label: "Търси", Path: "/withdrawnAuthorizations", Icon: <Search />, Permission: PermissionType.Read },
    Preview: {
      Label: "Преглед",
      Path: "/withdrawnAuthorizations/preview/:id",
      Icon: <VisibilityOutlined />,
      Permission: PermissionType.Read,
    },
    Print: {
      Label: "Принтирай",
      Path: "",
      Icon: <Print />,
      Permission: PermissionType.Read,
    },
    HistoryPreview: {
      Label: "",
      Path: "/withdrawnAuthorizations/history-preview/:id",
      Permission: PermissionType.Read,
    },
  },
};
